import { render, staticRenderFns } from "./AdminMain.vue?vue&type=template&id=5606f6bd&scoped=true"
import script from "./AdminMain.vue?vue&type=script&lang=js"
export * from "./AdminMain.vue?vue&type=script&lang=js"
import style0 from "./AdminMain.vue?vue&type=style&index=0&id=5606f6bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5606f6bd",
  null
  
)

export default component.exports